import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';

import useConfig from 'Context/ConfigContext/configHooks';
import useCapacitorStorage from 'Util/Hooks/useCapacitorStorage';
import { useAllMyCoursesData, MY_COURSES_MODE } from 'Domain/MyCourseData';
import { myProfile } from 'Redux/user-profile/selectors';
import { useCapacitor } from 'Util/Capacitors';

import FeatureAnnouncementModal from '../../Components/FeatureAnnouncement';

const FeatureAnnouncement = ({ user }) => {
  const { myCourses } = useConfig();
  const { openUrl } = useCapacitor();
  const history = useHistory();

  const coursesConditions = myCourses?.announcement?.conditions?.courses ?? [];
  const configVersion = myCourses?.announcement?.version;
  const enableFeatureAnnouncement = myCourses?.enableFeatureAnnouncement ?? false;
  const [localVersion, setLocalAnnouncementVersion] = useCapacitorStorage(
    0,
    `${user?.id ? `${user.id}_` : ''}announcement_version`
  );

  const { loading, data: myCoursesData } = useAllMyCoursesData({
    mode: MY_COURSES_MODE.ALL,
    fetchPolicy: 'cache-only',
  });

  const handleOpenUrl = (url) => (e) => {
    e.preventDefault();
    if (url?.match('/mygoal')) history.push(url);
    if (url?.includes('http')) openUrl(url);
  };

  let isAnyCourseMatch = true;

  if (Array.isArray(coursesConditions) && coursesConditions.length > 0) {
    isAnyCourseMatch = myCoursesData?.find((course) => {
      return coursesConditions.some((courseCode) => course.courseInfo.courseCode === courseCode);
    });
  }

  const isOpen = loading || !isAnyCourseMatch ? false : configVersion > localVersion;

  return (
    <FeatureAnnouncementModal
      open={isOpen && enableFeatureAnnouncement}
      announcements={myCourses?.announcement?.banners ?? []}
      onCompleted={() => setLocalAnnouncementVersion(configVersion)}
      onBannerClick={handleOpenUrl}
      onDetailClick={handleOpenUrl}
      fallbackBannerUrl={myCourses?.announcement?.fallbackBannerUrl}
    />
  );
};

export default connect((state) => ({ user: myProfile(state) }), {})(FeatureAnnouncement);
